export default __webpack_public_path__ + "static/media/141.1cf89ddc.jpg";